'use client';

import { useRouter } from 'next/navigation';
import { Button } from '@/features/button';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { getCdnUrl } from '@/utils/url';
import { useLanguage } from '../context/language-context-provider';
const MainBanner = () => {
  const {
    language
  } = useLanguage();
  const {
    isMobile
  } = useMobileDetect();
  const router = useRouter();
  const isEn = language === 'en';
  const handleLanguageChange = () => {
    router.push(isEn ? '/about-us' : '/about-us/en');
  };
  return <div className='homepage-container' data-sentry-component="MainBanner" data-sentry-source-file="main-banner.tsx">
            <div className='relative'>
                <Button size={isMobile ? 'small' : 'large'} graphicStyle='text' onClick={handleLanguageChange} className='absolute left-3 top-3 text-white hover:text-white' data-sentry-element="Button" data-sentry-source-file="main-banner.tsx">
                    {isEn ? 'Fa' : 'En'}
                </Button>
                <picture data-sentry-element="picture" data-sentry-source-file="main-banner.tsx">
                    <source media='(min-width: 640px)' srcSet={getCdnUrl('/_toad/images/about-us/banner.png')} />
                    <img width={1152} height={650} src={getCdnUrl('/_toad/images/about-us/banner-mobile.png')} alt={isEn ? 'About us' : 'درباره خانومی'} className='mb-4 mt-4 h-auto w-full lg:mb-0 lg:mt-10' />
                </picture>
            </div>
        </div>;
};
export default MainBanner;